import State from "@/helpers/pattern/state";
import { Usuario } from "@/models/seguridad/usuario";
import { modelIsModified } from "@/helpers/vue-mc";
import usuarioAPI from "@/services/seguridad/usuario";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";

/**
 * State Pattern for usuario form
 */
export default class UsuarioStates extends State {
  /**
   * Class constructor, important pass the required data within the states methods
   * @param {*} data Any type of data that you want available within the states methods
   */

  constructor(data) {
    super(data);
  }

  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) {
            this.clear();
            $data.croppaRemove();
            $data.usuario.foto = "/static/img/user_thumbnail.jpg";
            $data.usuario.fotoMiniatura = "/static/img/user_thumbnail.jpg";
            this.loadImage();
          }
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.usuario = new Usuario();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.usuario) || $data.view.action.submit.busy || !modelIsModified($data.usuario);
      }
      , loadImage({ $data }) {
        try {
          let image = new Image();

          // Notice: it's necessary to set "crossorigin" attribute before "src" attribute.
          image.setAttribute("crossorigin", "anonymous");
          image.src = $data.usuario.foto;

          let orientation = 1;
          image.onload = () => {
            $data.croppa._onload(image, orientation);
          };
          $data.croppa.refresh();
        } catch (error) {
          console.log(error);
        }
      }
    };
  }
  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.resetValidators();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;

          // View configuration form
          $data.view.elem.input.username.disabled = false;

          $data.fechaalta = null;
        }
        , async submit({ $data }, {
          username, nombre, telefono, interno, celular, correoElectronico, enabled, activo, foto, fotoMiniatura, tipoUsuario, idVendor, idRep
        }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await usuarioAPI.save({
              username: username.toLowerCase()
              , nombre
              , telefono
              , interno
              , celular
              , correoElectronico
              , enabled
              , activo
              , foto
              , fotoMiniatura
              , tipoUsuario
              , idVendor
              , idRep
              , tts: false
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.usuarioTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, {
          username, nombre, telefono, interno, celular, correoElectronico, enabled, activo, foto, fotoMiniatura, tipoUsuario, idVendor, idRep
        }) {
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;
          $data.view.elem.button.enabled.class.current = enabled ? $data.view.elem.button.enabled.class.disabled : $data.view.elem.button.enabled.class.enabled;
          $data.view.elem.button.enabled.title.current = enabled ? $data.view.elem.button.enabled.title.disabled : $data.view.elem.button.enabled.title.enabled;

          // View configuration form
          $data.view.elem.input.username.disabled = true;

          // para que no se asignen como string sino como numero y se pueda seleccionar la opcion del combo
          idVendor = idVendor * 1;
          idRep = idRep * 1;

          $data.usuario = new Usuario({
            username
            , nombre
            , telefono
            , interno
            , celular
            , correoElectronico
            , enabled
            , activo
            , foto: foto || "/static/img/user_thumbnail.jpg"
            , fotoMiniatura: fotoMiniatura || "/static/img/user_thumbnail.jpg"
            , tipoUsuario
            , idVendor
            , idRep
            , tts: false
          });

          this.loadImage();
          this.resetValidators();
          scrollToForm($data);
        }
        , async submit({ $data, $setState }, {
          username, nombre, telefono, interno, celular, correoElectronico, enabled, activo, foto, fotoMiniatura, tipoUsuario, idVendor, idRep
        }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await usuarioAPI.update({
              username
              , nombre
              , telefono
              , interno
              , celular
              , correoElectronico
              , enabled
              , activo
              , foto
              , fotoMiniatura
              , tipoUsuario
              , idVendor
              , idRep
              , tts: false
            });

            $data.$refs.usuarioTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/seguridad/usuario/usuario-states.js